import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const DragReorderView = ({
  isVisible,
  workouts = [], // Default to empty array to prevent undefined errors
  onDragEnd,
  onSaveChanges,
  onClose
}) => {
  if (!isVisible) return null;

  return (
    <div className="workoutul">
      <div className="header d-flex justify-content-end my-3">
        {workouts?.length > 1 && (
          <button className="button" onClick={onSaveChanges}>
            Save changes
          </button>
        )}
      </div>
      
      <DragDropContext onDragEnd={onDragEnd}>
        {workouts?.map((item, index) => (
          <Droppable
            key={item?.id?.toString()}
            droppableId={item?.id?.toString()}
            direction="vertical"
          >
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="exercise-list"
              >
                <Draggable
                  key={item?.id?.toString()}
                  draggableId={item?.id?.toString()}
                  index={index}
                >
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="exercise-item"
                    >
                      {item.name}
                      <i className="fa-solid fa-bars"></i>
                    </li>
                  )}
                </Draggable>
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        ))}
      </DragDropContext>
    </div>
  );
};

export default DragReorderView;
